export {DestinationSelector, type DestinationSelectorInstance, type DestinationSelectorConfig} from "./destination-selector.model";
